module.exports = __webpack_public_path__ + "assets/fox404_light.png";